module.exports = __webpack_public_path__ + "static/assets/414fef756c7cec8f8f131a0b4be135b0.gif";